import React from "react";
import { ConfigProvider } from "antd";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./redux";
import reportWebVitals from "./reportWebVitals";
import "./ui-kit/typography/brand-fonts.css";
import "./index.css";
import Init from "./Init";
import ErrorBoundary from "./components/ErrorBoundary";
import { GlobalToastProvider } from "./components/Toast";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <ConfigProvider theme={{ hashed: false }}>
        <GlobalToastProvider>
          <Init />
        </GlobalToastProvider>
      </ConfigProvider>
    </Provider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
